import { gql } from "@apollo/client";
import { UserApplication } from "../types";
import { UserApplicationSessionEvent, userApplicationSessionEventFragment } from "../fragments";

export const STREAM_USER_APPLICATION_SESSION_EVENTS = gql`
  subscription StreamUserApplicationSessionEvents(
    $application: user_application_enum!
    $itemId: uuid!
    $since: timestamptz!
  ) {
    userApplicationSessionEventStream: user_application_session_event_stream(
      cursor: { initial_value: { created_at: $since }, ordering: ASC }
      batch_size: 20
      where: { application: { _eq: $application }, item_id: { _eq: $itemId } }
    ) {
      ...userApplicationSessionEventFragment
    }
  }
  ${userApplicationSessionEventFragment}
`;

export interface StreamUserApplicationSessionEventsData {
  userApplicationSessionEventStream: UserApplicationSessionEvent[];
}

export interface StreamUserApplicationSessionEventsVars {
  application: UserApplication;
  itemId: string;
  since: string;
}
